<template>
  <v-menu offset-y bottom left>
    <template v-slot:activator="{ on }">
      <Button fab size="small" color="blue" icon="mdi-flash" v-on="on" />
    </template>

    <v-list dense nav>
      <v-list-item
        link
        :to="`/admin/organizations/${organizationId}/users`"
        v-if="pathIsNot(`/admin/organizations/:organizationId/users`)"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('common.users.user_other') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :to="`/admin/organizations/${organizationId}/revs`"
        v-if="pathIsNot(`/admin/organizations/:organizationId/revs`)"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('common.rev_other') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        link
        :to="`/admin/organizations/${organizationId}/challenges`"
        v-if="pathIsNot(`/admin/organizations/:organizationId/challenges`)"
        ><v-list-item-content>
          <v-list-item-title>
            {{ $t('common.challenge_other') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider
        v-if="pathIsNot(`/organization-settings/:organizationId`)"
        class="ma-0"
      ></v-divider>
      <v-list-item
        link
        :to="`/organization-settings/${organizationId}`"
        v-if="pathIsNot(`/organization-settings/:organizationId`)"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('common.button.edit') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        link
        :to="`/organization-settings/${organizationId}?option=admin`"
        v-if="pathIsNot(`/organization-settings/:organizationId`)"
      >
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('common.button.edit_private') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import Button from '@/components/UI/Button'
export default {
  name: 'OrganizationMenu',

  mixins: [mixin],
  components: { Button },

  computed: {
    organizationId() {
      return this.$route.params.organizationId
    },
  },
}
</script>
